import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;

@Component({
  selector: 'sod-assets-h',
  templateUrl: './sod-assets-h.component.html',
  styleUrls: ['./sod-assets-h.component.css'],
})

export class SODAssetsHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Start of Day Asset Position Event Log");

    /*<![CDATA[*/
  		var mainNav = "history-nav";
  		var sideNav = "side-nav-history-asset-positions";

  		$(document).ready(function() {
  			// prepare the data
  			var data = [ {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C",
  				"securityID" : "88AL992745",
  				"ccy" : "CAD",
  				"quantity" : "53.4K",
  				"price" : "220.87"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.577",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C",
  				"securityID" : "497GU9992",
  				"ccy" : "USD",
  				"quantity" : "1.7K",
  				"price" : "78.57"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account D",
  				"securityID" : "5509812337",
  				"ccy" : "CAD",
  				"quantity" : "43.9K",
  				"price" : "11.98"
  			}, {
  				"timestamp" : "5/5/2015 06:09:02.500",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account D",
  				"securityID" : "497GU9992",
  				"ccy" : "EUR",
  				"quantity" : "47.8K",
  				"price" : "78.57"
  			}, {
  				"timestamp" : "5/5/2015 06:09:42.564",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account E",
  				"securityID" : "497GU9992",
  				"ccy" : "GBP",
  				"quantity" : "23K",
  				"price" : "78.57"
  			}, {
  				"timestamp" : "5/5/2015 06:09:47.577",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account E",
  				"securityID" : "5509812337",
  				"ccy" : "CAD",
  				"quantity" : "37.3K",
  				"price" : "11.98"
  			} ];

  			// initialize jqxGrid
  			var source = {
  				localdata : data,
  				datafields : [ {
  					name : 'timestamp',
  					type : 'string'
  				}, {
  					name : 'user',
  					type : 'string'
  				}, {
  					name : 'ipAddress',
  					type : 'string'
  				}, {
  					name : 'accountCode',
  					type : 'string'
  				}, {
  					name : 'securityID',
  					type : 'string'
  				}, {
  					name : 'ccy',
  					type : 'string'
  				}, {
  					name : 'quantity',
  					type : 'string'
  				}, {
  					name : 'price',
  					type : 'string'
  				} ]
  			};
  			var settings = defaultGridViewSettings("#jqxgrid", source);
  			settings.columns = [ {
  				text : 'Timestamp',
  				columntype : 'textbox',
  				datafield : 'timestamp',
  				width : '160'
  			}, {
  				text : 'User',
  				columntype : 'textbox',
  				datafield : 'user',
  				width : '100'
  			}, {
  				text : 'IP Address',
  				columntype : 'textbox',
  				datafield : 'ipAddress',
  				width : '80'
  			}, {
  				text : 'Account',
  				columntype : 'textbox',
  				datafield : 'accountCode',
  				width : '120'
  			}, {
  				text : 'Security ID',
  				columntype : 'textbox',
  				datafield : 'securityID',
  				width : '120'
  			}, {
  				text : 'Ccy',
  				columntype : 'textbox',
  				datafield : 'ccy',
  				width : '100'
  			}, {
  				text : 'Quantity',
  				columntype : 'textbox',
  				datafield : 'quantity',
  				width : '100'
  			}, {
  				text : 'Price',
  				columntype : 'textbox',
  				datafield : 'price',
  				width : '100'
  			} ];
  			$("#jqxgrid").jqxGrid(settings);
  		});
  	/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/sod-assets-h/sod-assets-h.component.ts